module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(_vm.content) ? _c('p', {
    ref: "con",
    class: _vm.isHideFlag ? "line-5" : '',
    staticStyle: {
      "-webkit-box-orient": "vertical"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.replace(/(\r\n|\n|\r)/gm, '<br />'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHideFlag) ? _c('div', {
    class: _vm.isHideFlag ? 'unfold' : 'fold',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.unfold.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.unfoldText) + " "), _c('span', {
    staticClass: "arrow-down"
  })]) : _vm._e(), _vm._v(" "), (!!_vm.image) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "alt": ""
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c5ca4ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news_stream/theme-remark.vue
// module id = 858
// module chunks = 2